/**
 * шапка при скроле
 */
class headScroll {
    scrollTimerId = null

    constructor() {
        window.addEventListener('scroll', this.show.bind(this));
    }

    show() {
        if (this.scrollTimerId) {
            clearTimeout(this.scrollTimerId)
        }

        if (!document.body.classList.contains('open-head')) {
            document.body.classList.add('open-head')
        }

        this.scrollTimerId = setTimeout(() => {
            if (!document.body.getAttribute('open-head')) {
                document.body.classList.remove('open-head')
            }
        }, 2000)
    }
}

export const HeadScroll = new headScroll()